import { useState, useEffect } from "react";
import Restaurants from "../components/RestaurantsCard";
import defaultImage from "../assets/images/cuisines/default.jpeg";
import { restaurantService } from "../services";
import { RestaurantI } from "../utils/types";

const PopularRestaurant = () => {
  const [restaurants, setRestaurants] = useState<RestaurantI[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchRestaurants = async () => {
      try {
        setLoading(true);
        const response: any = await restaurantService.getUserRestaurants({
          page: 1,
          limit: 6,
        });
        setRestaurants(response.data || []);
        setError(null);
      } catch (err: any) {
        console.error("Error fetching restaurants:", err);
        setError(err.message || "Failed to load restaurants");
      } finally {
        setLoading(false);
      }
    };

    fetchRestaurants();
  }, []);

  // // Helper function to check if restaurant is currently open
  // const isRestaurantOpen = (restaurant: RestaurantI): "open" | "closed" => {
  //   const now = new Date();
  //   const currentDay = ["SUN", "MON", "TUE", "WED", "THU", "FRI", "SAT"][now.getDay()];
    
  //   // Check if restaurant operates today
  //   if (!restaurant.operatingDays.includes(currentDay)) {
  //     return "closed";
  //   }

  //   const currentTime = now.getHours() * 60 + now.getMinutes();
  //   const [openHour, openMin] = restaurant.operatingHours.openTime.split(":").map(Number);
  //   const [closeHour, closeMin] = restaurant.operatingHours.closeTime.split(":").map(Number);
    
  //   const openTime = openHour * 60 + openMin;
  //   let closeTime = closeHour * 60 + closeMin;
    
  //   // Handle case where closing time is after midnight
  //   if (closeTime < openTime) {
  //     closeTime += 24 * 60;
  //   }
    
  //   if (currentTime >= openTime && currentTime <= closeTime) {
  //     return "open";
  //   }
    
  //   return "closed";
  // };


  if (loading) {
    return (
      <div>
        <div className="flex justify-between items-center">
          <p className="text-gray-900 dark:text-white text-left font-urbanist text-2xl font-semibold leading-[140%] my-4">
            Popular Restaurants
          </p>
        </div>
        <div className="flex justify-center items-center py-8">
          <p className="text-gray-500 dark:text-gray-400">Loading restaurants...</p>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div>
        <div className="flex justify-between items-center">
          <p className="text-gray-900 dark:text-white text-left font-urbanist text-2xl font-semibold leading-[140%] my-4">
            Popular Restaurants
          </p>
        </div>
        <div className="flex justify-center items-center py-8">
          <p className="text-red-500 dark:text-red-400">{error}</p>
        </div>
      </div>
    );
  }

  if (restaurants.length === 0) {
    return (
      <div>
        <div className="flex justify-between items-center">
          <p className="text-gray-900 dark:text-white text-left font-urbanist text-2xl font-semibold leading-[140%] my-4">
            Popular Restaurants
          </p>
        </div>
        <div className="flex justify-center items-center py-8">
          <p className="text-gray-500 dark:text-gray-400">No restaurants available</p>
        </div>
      </div>
    );
  }

  return (
    <div>
      <div className="flex justify-between items-center">
        <p className="text-gray-900 dark:text-white text-left font-urbanist text-2xl font-semibold leading-[140%] my-4">
          Popular Restaurants
        </p>
      </div>
      
      {/* Mobile: Horizontal scroll with 1 item visible at a time, snap scroll */}
      {/* <div className="md:hidden overflow-x-auto scrollbar-hide snap-x snap-mandatory">
        <div className="flex gap-4 pb-2">
          {restaurants.map((restaurant, index) => (
            <div key={restaurant._id || index} className="snap-start flex-shrink-0 w-full">
              <Restaurants
                name={restaurant.businessName}
                image={restaurant?.kitchenPhotos?.[0]}
                status={isRestaurantOpen(restaurant)}
                star="4.5"
                reviews="0"
                time={`${restaurant.avgPreparationTime} min`}
                location={restaurant.location.city}
              />
            </div>
          ))}
        </div>
      </div> */}

      {/* Desktop: Grid layout with 3 columns */}
      <div className="grid grid-cols-1  md:grid-cols-3 gap-4">
        {restaurants.map((restaurant, index) => (
          <Restaurants
            key={restaurant._id || index}
            _id={restaurant._id}
            name={restaurant.businessName}
            image={restaurant?.kitchenPhotos?.[0] || defaultImage}
            status={restaurant.deliveryAvailable ? "open" : "closed"}
            star={String((restaurant as any).rating?.averageRating ?? 4.5)}
            reviews={String((restaurant as any).rating?.totalRatings ?? 0)}
            time={`${restaurant.avgPreparationTime} min`}
            location={restaurant.location.city}
          />
        ))}
      </div>
    </div>
  );
};

export default PopularRestaurant;
